import Image from "next/image";

export const FeatureSplashImage = ({
  src,
  rotate,
}: {
  src: string;
  rotate: boolean;
}) => {
  const transform = rotate ? "rotate-[90deg] translate-y-[-15%]" : "translate-y-[-10%]";
  return (
    <div
      className={
        "bg-map2 absolute left-0 top-0 -z-[1] h-[calc(40vh)] max-h-[450px] w-full overflow-hidden bg-[0%_0%] bg-repeat gradient-mask-b-80 md:h-[calc(50vh)]"
      }
    >
      {/* map gradient */}
      <div
        className={"absolute h-full w-full"}
        style={{
          backgroundImage: `
          linear-gradient(130deg, rgba(2, 2, 2, 0.5) 0%, rgba(2, 2, 2, 0.05) 90%)`,
        }}
      />

      {/* feature img */}
      <div
        className={
          "absolute right-0 top-0 h-full w-full max-w-[750px] duration-700 animate-in fade-in gradient-mask-b-30 sm:w-2/3 md:w-full xl:w-2/3"
        }
      >
        <div className="absolute h-full w-full duration-1000 animate-in fade-in gradient-mask-l-30">
          <Image
            key={src}
            priority={true}
            height={700}
            width={700}
            className={`absolute right-0 ${transform} gradient-mask-l-80`}
            alt={src}
            src={src}
          />
        </div>
      </div>

      {/* gradient */}
      <div
        className={`absolute h-full w-full ${rotate && "gradient-mask-b-30"}`}
        style={{
          backgroundImage: `
          linear-gradient(240deg, rgba(2, 2, 2, 0.3) 0%, rgba(2, 2, 2, 0.05) 40%), 
          linear-gradient(120deg, rgba(2, 2, 2, 0.4) 0%, rgba(2, 2, 2, 0.2) 40%), 
          linear-gradient(180deg, rgba(2, 2, 2, 0.6) 0%, rgba(2, 2, 2, 0.2) 40%)`,
        }}
      />
    </div>
  );
};
